let stopHandler = null;

export const registerSessionStopHandler = (fn) => {
  stopHandler = typeof fn === 'function' ? fn : null;
};

export const getSessionStopHandler = () => {
  return stopHandler;
};

export const clearSessionStopHandler = () => {
  stopHandler = null;
};